import React, { useState, useEffect } from 'react';
import { NOTIFICATIONS } from '../../Engauge/constants/apiEndpoints';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  let primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
  if (!primaryColor) {
    const btnSample = document.querySelector('.btn-primary');
    if (btnSample) {
      primaryColor = getComputedStyle(btnSample).backgroundColor;
    } else {
      primaryColor = '#337ab7';
    }
  }

  // Poll every 30 s
  useEffect(() => {
    fetchNotifications();
    const id = setInterval(fetchNotifications, 30000);
    return () => clearInterval(id);
  }, []);

  const fetchNotifications = () => {
    return fetch(NOTIFICATIONS)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setNotifications(data);
        } else if (data.notifications) {
          setNotifications(data.notifications);
        }
      })
      .catch(() => {});
  };

  const markAsRead = (id, link) => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    fetch(`${NOTIFICATIONS}/${id}/mark_as_read`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        setNotifications(prev => prev.filter(n => n.id !== id));
        if (link) {
          window.location = link;
        }
      });
  };

  const dismiss = (id, e) => {
    e.stopPropagation();
    markAsRead(id);
  };

  return (
    <div className="notification-bell-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        className="btn btn-primary dropdown-toggle btn-circle btn-lg"
        onClick={() => {
          if (!open) {
            fetchNotifications().then(() => setOpen(true));
          } else {
            setOpen(false);
          }
        }}
        title="Notifications"
      >
        <span className="glyphicon glyphicon-bell notification-icon" aria-hidden="true"></span>
        {notifications.length > 0 && (
          <span
            style={{
              position: 'absolute',
              top: '5px',
              right: '7px',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              background: 'red'
            }}
          />
        )}
      </button>

      {open && notifications.length > 0 && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            marginTop: '5px',
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            zIndex: 2000,
            width: '300px',
            maxHeight: '425px',
            overflowY: 'auto'
          }}
        >
          <div style={{ padding: '8px 10px', borderBottom: '1px solid #eee', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Notifications</span>
            <button
              className="dismiss-all-btn"
              onClick={(e) => { e.stopPropagation(); notifications.forEach(n => markAsRead(n.id)); }}
              style={{ background: 'transparent', border: 'none', color: 'black', cursor: 'pointer', fontSize: '0.9rem', padding: '2px 6px', borderRadius: '4px', transition: 'all 0.15s ease' }}
            >
              Dismiss&nbsp;All
            </button>
          </div>
          {notifications.map(n => (
            <div
              key={n.id}
              style={{
                padding: '10px 10px 10px 6px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                borderLeft: hovered === n.id ? `4px solid ${primaryColor}` : '4px solid transparent',
                position: 'relative'
              }}
              onMouseEnter={() => setHovered(n.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => markAsRead(n.id, n.link)}
            >
              <div style={{ fontSize: '1.2rem' }}>
                {(n.message || n.action).split(/\n+/).map((line, idx) => (
                  <div key={idx} style={{ marginTop: idx === 0 ? 0 : '4px', whiteSpace: 'normal' }}>
                    {(() => {
                      const labels = ['Score', "Teacher's Comment", 'Question', 'Your Answer'];
                      const match = line.match(/^([\w' ][\w' ]*?):\s*(.*)$/);
                      if (match && labels.includes(match[1])) {
                        return <><strong>{match[1]}:</strong> {match[2]}</>;
                      }
                      return line;
                    })()}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '4px' }}>
                {new Date(n.created_at).toLocaleString()}
              </div>
              <span
                onClick={(e) => dismiss(n.id, e)}
                className="notif-close-btn"
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '6px',
                  color: '#888',
                  borderRadius: '50%',
                  width: '18px',
                  height: '18px',
                  lineHeight: '16px',
                  textAlign: 'center',
                  fontSize: '14px',
                  cursor: 'pointer',
                  transition: 'all 0.15s ease'
                }}
              >
                &times;
              </span>
            </div>
          ))}
        </div>
      )}

      {/* hover style injected once */}
      <style>{`.notif-close-btn:hover { background: red !important; color: #fff !important; }
                .dismiss-all-btn:hover { background: red !important; color: #fff !important; }`}</style>
    </div>
  );
};

export default NotificationBell; 
